import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-102d2ce6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "os-selection"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "os-text" }
const _hoisted_4 = { class: "os-name" }
const _hoisted_5 = { class: "os-version" }
const _hoisted_6 = { class: "download-main" }
const _hoisted_7 = {
  key: 0,
  class: "distro-tabs"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "download-cards" }
const _hoisted_10 = { class: "download-card-title" }
const _hoisted_11 = {
  key: 1,
  class: "download-card-desc"
}
const _hoisted_12 = {
  key: 1,
  class: "download-empty"
}

import { PropType, toRef } from 'vue'
import CmSvgIcon from '@/components/cm-svg-icon/cm-svg-icon.vue'
import { useI18n } from 'vue-i18n'
import type { DeployDownloadSource } from './deploy-package-download.types'
import { useDeployPackageDownload } from './use-deploy-package-download'


export default /*#__PURE__*/_defineComponent({
  __name: 'deploy-package-download',
  props: {
  data: {
    type: Object as PropType<DeployDownloadSource>,
    required: true,
  },
},
  setup(__props) {

const props = __props

const { t, locale } = useI18n()
const dataRef = toRef(props, 'data')

const {
  IS_JP_ONLY_BUILD,
  selectedOS,
  selectedLinuxTabId,
  osList,
  linuxDistroTabEntries,
  displayDownloadPackages,
  handleDownload,
} = useDeployPackageDownload(dataRef, t, locale)

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["download-package-content", { 'is-jp-only-build': _unref(IS_JP_ONLY_BUILD) }])
  }, [
    (!_unref(IS_JP_ONLY_BUILD))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(osList), (os) => {
            return (_openBlock(), _createElementBlock("div", {
              key: os.type,
              class: _normalizeClass(["os-item el-card", { 'is-active': _unref(selectedOS) === os.type }]),
              onClick: ($event: any) => (selectedOS.value = os.type)
            }, [
              _createVNode(CmSvgIcon, {
                name: os.icon,
                alt: os.name,
                class: "os-icon",
                size: 32,
                monochrome: ""
              }, null, 8, ["name", "alt"]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(os.name), 1),
                _createElementVNode("div", _hoisted_5, _toDisplayString(os.version), 1)
              ])
            ], 10, _hoisted_2))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      (!_unref(IS_JP_ONLY_BUILD) && _unref(selectedOS) === 'linux' && _unref(linuxDistroTabEntries).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(linuxDistroTabEntries), (tab) => {
              return (_openBlock(), _createElementBlock("button", {
                key: tab.tabId,
                type: "button",
                class: _normalizeClass(["distro-tab", { 'is-active': _unref(selectedLinuxTabId) === tab.tabId }]),
                onClick: ($event: any) => (selectedLinuxTabId.value = tab.tabId)
              }, _toDisplayString(tab.label), 11, _hoisted_8))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayDownloadPackages), (packageItem, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(["download-card el-card", { 'has-wide-corner-icon': packageItem.cornerIconWide }])
          }, [
            (packageItem.cornerIcon)
              ? (_openBlock(), _createBlock(CmSvgIcon, {
                  key: 0,
                  class: _normalizeClass(["download-card-corner-icon", { 'is-wide': packageItem.cornerIconWide }]),
                  name: packageItem.cornerIcon,
                  size: packageItem.cornerIconWide ? 48 : 24,
                  monochrome: ""
                }, null, 8, ["class", "name", "size"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, _toDisplayString(packageItem.title), 1),
            (packageItem.description)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(packageItem.description), 1))
              : _createCommentVNode("", true),
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              class: "btn-download cm-ui-mt15",
              disabled: !packageItem.url,
              onClick: ($event: any) => (_unref(handleDownload)(packageItem.url))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('terminalDeploy.downloadNow')), 1)
              ]),
              _: 2
            }, 1032, ["disabled", "onClick"])
          ], 2))
        }), 128))
      ]),
      (_unref(displayDownloadPackages).length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t('terminalDeploy.noPackageAvailable')), 1))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})